export const getCodePromoList = (state) => state.codePromos
export const getCodePromoStatus = (state) => state.codePromoStatus
export const getDiscountTypes = (state) => state.discountTypes

